import { render, staticRenderFns } from "./usefulLinks.vue?vue&type=template&id=5313f96d&scoped=true&"
var script = {}
import style0 from "./usefulLinks.vue?vue&type=style&index=0&id=5313f96d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../Retirement Planner.Admin/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5313f96d",
  null
  
)

export default component.exports